var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReviewStarFull = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 14 13"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#review-star-full_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2B6638",
  d: "M13.98 4.911a.295.295 0 0 0-.293-.218H8.813L7.292.201C7.257.084 7.136 0 6.998 0s-.26.084-.294.201l-1.52 4.492H.308a.33.33 0 0 0-.31.218c-.036.134 0 .268.12.335l3.94 2.783-1.503 4.492c-.034.134 0 .268.121.352.052.033.121.05.19.05.07 0 .138-.017.19-.067l3.941-2.782 3.94 2.782a.32.32 0 0 0 .381 0 .34.34 0 0 0 .121-.352L9.936 8.012l3.941-2.782c.104-.067.156-.202.104-.319z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "review-star-full_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v12.923H0z"
})))));
export default SvgReviewStarFull;